export default "__VITE_ASSET__D4wNGK_6__"